<template>
  <div>
    <div class="detail-header-wrap">
      <div class="title">订单信息</div>
      <div class="btn-wrap">
        <el-button
          type="primary"
          class="btn"
          @click="toOrderFollowClick"
        >进度</el-button>
        <el-button
          type="primary"
          class="btn"
          @click="dispatchOrderClick"
          v-if="(orderInfo.order_status === '2' && !orderInfo.salesman_name) || (orderInfo.order_status === '8') || (orderInfo.order_status === '6')"
        >派单</el-button>
        <el-button
          type="primary"
          class="btn"
          @click="succHandleClick"
          v-if="orderInfo.order_status === '3'"
        >成功</el-button>
        <el-button
          type="primary"
          class="btn"
          @click="cancelOrderClick"
          v-if="(orderInfo.order_status === '6')|| (orderInfo.order_status === '8')"
        >撤单</el-button>
        <el-button
          type="primary"
          class="btn"
          @click="recallOrderClick"
          v-if="(orderInfo.order_status === '2' && !!orderInfo.salesman_name )|| (orderInfo.order_status === '3') || (orderInfo.order_status === '4')"
        >撤回</el-button>
        <span
          class="operation-item"
          v-if="orderInfo.order_status === '8' && orderInfo.order_tag === '1'"
          @click="refuseRejectClick"
        >完成</span>
        <!-- <el-button
          type="primary"
          class="btn"
          @click="toOrderComplete"
          v-if="(orderInfo.order_status === '4' && orderInfo.order_tag === '2') || (orderInfo.order_status === '8' && orderInfo.order_tag === '1')"
        >确认完成</el-button> -->
        <el-button
          type="primary"
          class="btn"
          @click="refoundClick"
          v-if="orderInfo.order_status === '11'"
        >即退</el-button>
        <el-button
          type="primary"
          class="btn"
          @click="refuseRefoundClick"
          v-if="orderInfo.order_status === '10'"
        >拒绝</el-button>
        <el-button
          type="primary"
          class="btn"
          @click="refoundClick"
          v-if="orderInfo.order_status === '10'"
        >同意</el-button>
        <el-button
          type="primary"
          class="btn"
          @click="closeOrderClick"
          v-if="orderInfo.order_status === '6' && orderInfo.order_tag === '2'"
        >关闭</el-button>
      </div>
    </div>
    <div class="order-info-wrap">
      <div class="left">
        <div class="item">
          <span class="sub-title">订单状态:</span>
          <span
            class="order-status"
            v-if="orderInfo.order_status === '1'"
          >待支付</span>
          <span
            class="order-status"
            v-if="orderInfo.order_status === '2'"
          >待处理</span>
          <span
            class="order-status"
            v-if="orderInfo.order_status === '3'"
          >处理中</span>
          <span
            class="order-status"
            v-if="orderInfo.order_status === '4'"
          >待确认</span>
          <span
            class="order-status"
            v-if="orderInfo.order_status === '5'"
          >已完成</span>
          <span
            class="order-status"
            v-if="orderInfo.order_status === '13'"
          >已撤回</span>
          <span
            class="order-status"
            v-if="orderInfo.order_status === '7'"
          >取消单</span>
          <span
            class="order-status"
            v-if="orderInfo.order_status === '8'"
          >已驳回</span>
          <span
            class="order-status"
            v-if="orderInfo.order_status === '9' && orderInfo.order_tag === '2'"
          >已关闭</span>
          <span
            class="order-status"
            v-if="orderInfo.order_status === '9' && orderInfo.order_tag === '1'"
          >已退款</span>
          <span
            class="order-status"
            v-if="orderInfo.order_status === '10'"
          >退款中</span>
          <span
            class="order-status"
            v-if="orderInfo.order_status === '11'"
          >未解决</span>
        </div>
        <div class="item">
          <span class="sub-title">下单用户昵称:</span>
          <span v-if="orderInfo.order_tag === '1'">{{orderInfo.user_name}}</span>
          <span v-else>管理员</span>
        </div>
        <div class="item">
          <span class="sub-title">服务项目:</span>
          <span>{{orderInfo.server_name}}</span>
        </div>
        <div class="item">
          <span class="sub-title">追加费用:</span>
          <span>¥{{orderInfo.order_append_price}}</span>
        </div>
        <div class="item">
          <span class="sub-title">追加类型:</span>
          <span>{{orderInfo.add_content}}</span>
        </div>
        <div class="item">
          <span class="sub-title">下单优惠:</span>
          <span>{{orderInfo.order_member_discount * 10}}折</span>
        </div>
        <div
          class="item"
          v-if="orderInfo.order_status === '9'"
        >
          <span class="sub-title">退款金额:</span>
          <span>¥{{orderInfo.refund_price}}</span>
        </div>
      </div>
      <div class="center">
        <div class="item">
          <span class="sub-title">订单编号:</span>
          <span>{{orderInfo.order_code}}</span>
        </div>
        <div class="item">
          <span class="sub-title">订单金额（元）:</span>
          <span>¥{{orderInfo.order_server_price}}</span>
        </div>
        <div class="item">
          <span class="sub-title">订单类型:</span>
          <span v-if="orderInfo.order_tag === '1'">线上订单</span>
          <span v-if="orderInfo.order_tag === '2'">线下订单</span>
        </div>
        <div class="item">
          <span class="sub-title">下单时间:</span>
          <span>{{orderInfo.create_time}}</span>
        </div>
        <div class="item">
          <span class="sub-title">支付方式:</span>
          <span v-if="orderInfo.order_tag === '1'">{{orderInfo.pay_type}}</span>
          <span v-else>线下支付</span>
        </div>
      </div>
      <!-- <div class="right">
        <div>
          <span
            class="sub-title"
            v-if="orderInfo.server_type === '1'"
          >商品链接:</span>
          <span
            class="sub-title"
            v-else
          >店铺链接:</span>
          <span class="goods_url">{{orderInfo.question_url}}</span>
        </div>
      </div> -->
    </div>
    <div>
      <div class="title">业务员信息</div>
      <div class="salesmaninfo-wrap">
        <div class="item">
          <span class="sub-title">业务员:</span>
          <span>{{orderInfo.salesman_name}}</span>
        </div>
        <div class="item">
          <span class="sub-title">佣金:</span>
          <span>{{(orderInfo.commission_rate*orderInfo.order_server_price).toFixed(2)}}元 ({{orderInfo.commission_rate*100}}%)</span>
        </div>
        <div class="item">
          <span class="sub-title">截止时间:</span>
          <span>{{orderInfo.deadline}}</span>
        </div>
      </div>
    </div>
    <div class="seller-info-wrap">
      <div class="title">联系信息</div>
      <div class="item-wrap">
        <div class="item">
          <span class="sub-title">商品连接:</span>
          <div
            v-for="item of orderInfo.linkList"
            :key="item"
            class="link"
          >{{item}}</div>
        </div>
        <div
          class="item"
          v-if="orderInfo.server_type === '1'"
        >
          <span class="sub-title">卖家旺旺:</span>
          <span>{{orderInfo.merchant_wangwang}}</span>
        </div>
        <div
          class="item"
          v-if="orderInfo.merchant_mobile"
        >
          <span class="sub-title">卖家手机号码:</span>
          <span>{{orderInfo.merchant_mobile}}</span>
        </div>
        <div
          class="item"
          v-if="orderInfo.server_type === '1'"
        >
          <span class="sub-title">买家旺旺:</span>
          <span>{{orderInfo.consumer_wangwang}}</span>
        </div>
        <!-- <div class="item">
          <span class="sub-title">消费者姓名:</span>
          <span>{{orderInfo.consumer_name}}</span>
        </div> -->
        <div
          class="item"
          v-if="orderInfo.consumer_mobile"
        >
          <span class="sub-title">手机号码:</span>
          <span>{{orderInfo.consumer_mobile}}</span>
        </div>
		
		<div
		  class="item"
		  v-if="orderInfo.consumer_name"
		>
		  <span class="sub-title">顾客姓名:</span>
		  <span>{{orderInfo.consumer_name}}</span>
		</div>
      </div>
    </div>
    <div class="seller-info-wrap">
      <div class="title">截图信息</div>
      <viewer
        :images="orderInfo.order_images"
        class="img-wrap"
      >
        <img
          v-for="src in orderInfo.order_images"
          :src="imgDomain + src"
          :key="src"
          class="situation_img"
        >
      </viewer>
    </div>
    <div
      class="auth-wrap"
      v-if="orderInfo.after_sale_type"
    >
      <div class="title">售后授权</div>
      <div
        class="auth-text"
        v-if="orderInfo.after_sale_type === '1'"
      >除处理费用外，商家还同意消费者申请退货退款 </div>
      <div
        class="auth-text"
        v-if="orderInfo.after_sale_type === '2'"
      >除处理费用外，商家还愿意额外支付消费者补偿款</div>
      <div
        class="auth-text"
        v-if="orderInfo.after_sale_type === '3'"
      >除处理费用外，商家还同意消费者不退货仅退款</div>
      <div
        class="auth-text"
        v-if="orderInfo.after_sale_type === '4'"
      >其他：{{orderInfo.other_sale_massage}}</div>
      <div
        class="item"
        v-if="orderInfo.after_sale_type === '2'"
      >
        <span class="sub-title">最大允许补偿金额:</span>
        <span class="order-status">¥{{orderInfo.compensation_price}}</span>
      </div>
    </div>
    <div
      class="situation-wrap"
      v-if="orderInfo.order_details"
    >
      <div class="title">情况概况</div>
      <!-- <div class="situation-tag">{{orderInfo.order_details_tag}}</div> -->
      <div class="situation-desc">{{orderInfo.order_details}}</div>
    </div>
    <div
      class="situation-wrap"
      v-if="orderInfo.order_supplement"
    >
      <div class="title">补充信息</div>
      <div class="situation-desc">{{orderInfo.order_supplement}}</div>
      <viewer
        :images="orderInfo.order_supplement_img"
        class="img-wrap"
      >
        <img
          v-for="src in orderInfo.order_supplement_img"
          :src="imgDomain + src"
          :key="src"
          class="situation_img"
        >
      </viewer>
    </div>
    <el-button
      type="primary"
      class="backBtn"
      @click="onBackClick"
    >返回</el-button>
    <common-dialog
      :title="dialogTitle"
      :dialogVisible="dialogVisible"
      :showClose="show_dialog_close"
      :showBtns="show_dialog_btns"
      @cancel="dialogCancelClick"
      @confirm="dialogConfirmClick"
      @dialog-close="dialogClose"
    >
      <div class="dialog-body-wrap">
        <div
          v-if="dialogType === 'order_follow_record'"
          class="follow_record_wrap"
        >
          <el-timeline v-if="order_follow_records.length">
            <el-timeline-item
              v-for="item in order_follow_records"
              :key="item.uuid"
              :timestamp="item.create_time"
            >
              <span :class="{record_tag: item.tag !==''}">{{item.tag}}</span>
              <div>{{item.content}}</div>
            </el-timeline-item>
          </el-timeline>
          <div v-else>暂无记录</div>
        </div>
        <div v-if="dialogType === 'dispatch_order'">
          <el-select
            v-model="selected_salesman_uuid"
            placeholder="请选择业务员"
          >
            <el-option
              v-for="item in salesman_list"
              :key="item.uuid"
              :label="item.user_name"
              :value="item.uuid"
            >
            </el-option>
          </el-select>
          <div class="commission_input-wrap">
            <label
              for="commission_input"
              class="input-label"
            >佣金比例：</label>
            <el-input
              v-model="orderInfoCopydata.commission_rate"
              id="commission_input"
              placeholder="请输入佣金比例"
              class="commission_rate"
            ></el-input>
            <span>%</span>
          </div>
        </div>
        <div v-if="dialogType === 'succ_handled'">
          确认成功处理？
        </div>
        <div v-if="dialogType === 'cancel_order'">
          <el-radio-group
            v-model="cancel_resaon"
            class="radio-group"
          >
            <el-radio label="客户不愿意协商">客户不愿意协商</el-radio>
            <el-radio label="无法联系客户">无法联系客户</el-radio>
            <el-radio label="商家要求撤单">商家要求撤单</el-radio>
            <el-radio label="other">其他原因</el-radio>
          </el-radio-group>
          <el-input
            v-if="cancel_resaon === 'other'"
            type="textarea"
            placeholder="请输入文字"
            v-model="cancel_order_input"
            maxlength="100"
            show-word-limit
            :rows="4"
            class="remark-input"
          >
          </el-input>
          <div class="img-wrap">
            <label class="img-label">图片上传({{reasons_for_cancellation_img.length}}/6)</label>
            <imageUpload
              v-model="reasons_for_cancellation_img"
              :limit="6"
            />
          </div>
        </div>
        <div v-if="dialogType === 'recall_order'">
          <el-input
            type="textarea"
            placeholder="请详细描述撤回原因"
            v-model="withdraw_reasons"
            maxlength="100"
            show-word-limit
            :rows="4"
            class="remark-input"
          >
          </el-input>
          <div class="img-wrap">
            <label class="img-label">图片上传({{withdraw_reasons_img.length}}/6)</label>
            <imageUpload
              v-model="withdraw_reasons_img"
              :limit="6"
            />
          </div>
        </div>
        <div v-if="dialogType === 'order_complete'">
          确认订单已完成？
        </div>
        <div v-if="dialogType === 'refuse-refound'">
          是否拒绝退款？
        </div>
        <div v-if="dialogType === 'refound'">
          <el-input
            v-model="refund_price"
            placeholder="请输入退款金额"
          ></el-input>
        </div>
        <div v-if="dialogType === 'close_order'">
          确认关闭订单？
        </div>
        <div
          v-if="dialogType === 'refuse_reject'"
          class="refuse-wrap"
        >
          <el-input
            type="textarea"
            placeholder="请输入文字"
            v-model="reason_for_rejection"
            maxlength="100"
            show-word-limit
            :rows="4"
            class="remark-input"
          >
          </el-input>
          <div class="img-wrap">
            <imageUpload
              v-model="img"
              :limit="6"
            />
            <label>图片上传({{img.length}}/6)</label>
          </div>
        </div>
      </div>
    </common-dialog>
  </div>
</template>

<script>
import { orderDetail, orderFollowRecord, changeorder } from "@/api/order";
import { mapState } from "vuex";
import CommonDialog from "@/components/CommonDialog";
import imageUpload from "@/components/ImageUpload";

export default {
  name: "orderdetail",
  data() {
    return {
      orderInfo: {},
      orderInfoCopydata: {},
      dialogTitle: "",
      dialogVisible: false,
      dialogType: "",
      show_dialog_close: false,
      show_dialog_btns: true,
      uuid: "",
      order_follow_records: [],
      selected_salesman_uuid: "",
      cancel_resaon: "",
      cancel_order_input: "",
      refund_price: "",
      reasons_for_cancellation_img: [],
      withdraw_reasons_img: [], //撤回图片
      withdraw_reasons: "",
      reason_for_rejection: "",
      img: []
    };
  },
  computed: {
    ...mapState(["salesman_list", "imgDomain"])
  },
  components: {
    CommonDialog,
    imageUpload
  },
  mounted() {
    let uuid = this.$route.query.uuid;
    if (uuid) {
      this.uuid = uuid;
      this.getOrderDetail(uuid);
    }
  },
  methods: {
    async getOrderDetail(uuid) {
      const { data, status } = await orderDetail(uuid);
      if (status !== 200) return;
      data.linkList = data.question_url.split(",");
      this.orderInfo = data;
      this.orderInfoCopydata = JSON.parse(JSON.stringify(data));
      console.log(data, "详情数据");
    },
    refuseRejectClick() {
      this.dialogType = "refuse_reject";
      this.dialogTitle = "请输入拒绝驳回原因";
      this.dialogVisible = true;
    },
    onBackClick() {
      this.$router.go(-1);
    },
    dialogCancelClick() {
      this.dialogVisible = false;
    },
    async dialogConfirmClick() {
      switch (this.dialogType) {
        case "order_complete": {
          const { status } = await changeorder({ type: "1" }, this.uuid);
          if (status === 200) this.dialogVisible = false;
          break;
        }
        case "cancel_order": {
          if (
            (this.cancel_resaon === "other" &&
              this.cancel_order_input === "") ||
            !this.cancel_resaon
          ) {
            this.$message("撤单理由不能为空");
            break;
          }
          let reasons_for_cancellation =
            this.cancel_resaon === "other"
              ? this.cancel_order_input
              : this.cancel_resaon;
          let postData = {
            type: "2",
            reasons_for_cancellation,
            reasons_for_cancellation_img: this.reasons_for_cancellation_img
          };
          const { status } = await changeorder(postData, this.uuid);
          if (status === 200) this.dialogVisible = false;
          break;
        }
        case "recall_order": {
          if (!this.withdraw_reasons) {
            this.$message("撤回理由不能为空");
            break;
          }

          let postData = {
            type: "15",
            withdraw_reasons: this.withdraw_reasons,
            withdraw_reasons_img: this.withdraw_reasons_img
          };
          const { status } = await changeorder(postData, this.uuid);
          if (status === 200) this.dialogVisible = false;
          break;
        }
        case "refound": {
          if (!this.refund_price) {
            this.$message("退款金额不能为空");
            break;
          }
          if (this.refund_price > this.orderInfo.order_total_price) {
            this.$message("退款金额不能大于订单金额");
            break;
          }
          let postData = {
            type: "6",
            refund_price: this.refund_price
          };
          const { status } = await changeorder(postData, this.uuid);
          if (status === 200) this.dialogVisible = false;
          break;
        }
        case "refuse-refound": {
          let postData = {
            type: "14"
          };
          const { status } = await changeorder(postData, this.uuid);
          if (status === 200) this.dialogVisible = false;
          break;
        }
        case "dispatch_order": {
          if (
            !this.selected_salesman_uuid ||
            !this.orderInfoCopydata.commission_rate
          ) {
            this.$message("请选择业务员和输入提成比例");
            break;
          }
          const { order_status } = this.orderInfoCopydata;
          //待处理未分配业务员时 type为3 ，驳回、撤单时type 为4
          let type = order_status === "2" ? "3" : "4";
          let postData = {
            type,
            commission_rate: this.orderInfoCopydata.commission_rate / 100,
            salesman_uuid: this.selected_salesman_uuid
          };
          const { status } = await changeorder(postData, this.uuid);
          if (status === 200) this.dialogVisible = false;
          this.selected_salesman_uuid = "";
          break;
        }
        case "succ_handled": {
          const { status } = await changeorder({ type: "8" }, this.uuid);
          if (status === 200) this.dialogVisible = false;
          break;
        }
        case "close_order": {
          const { status } = await changeorder({ type: "5" }, this.uuid);
          if (status === 200) this.dialogVisible = false;
          break;
        }
        case "refuse_reject": {
          if (!this.reason_for_rejection) {
            this.$message("拒绝理由不能为空");
            break;
          }
          let postData = {
            type: "9",
            reason_for_rejection: this.reason_for_rejection,
            img: this.img
          };
          const { status } = await changeorder(postData, this.order_row.uuid);
          if (status === 200) this.dialogVisible = false;
          break;
        }
      }
    },
    dialogClose() {
      this.dialogVisible = false;
      //每次关闭把dialog是否需要关闭按钮 和 是否需要确认取消按钮值重置
      this.show_dialog_close = false;
      this.show_dialog_btns = true;
      this.getOrderDetail(this.uuid);
    },
    async toOrderFollowClick() {
      this.$router.push({
        path: "/order-list/order-record",
        query: {
          uuid: this.uuid,
          order_code: this.orderInfo.order_code
        }
      });
      // this.show_dialog_close = true;
      // this.show_dialog_btns = false;
      // this.dialogType = "order_follow_record";
      // this.dialogTitle = "订单跟进记录";
      // this.dialogVisible = true;
      // const { data, status } = await orderFollowRecord(
      //   { page_index: 1, page_size: 99 },
      //   this.uuid
      // );
      // //有数据时才更新store数据
      // if (status === 200) {
      //   this.order_follow_records = data.data;
      //   console.log(data, "订单跟进记录");
      // }
    },
    dispatchOrderClick() {
      this.orderInfoCopydata.commission_rate *= 100;
      this.dialogType = "dispatch_order";
      this.dialogTitle = "派单";
      this.dialogVisible = true;
    },
    succHandleClick() {
      this.dialogType = "succ_handled";
      this.dialogTitle = "成功处理";
      this.dialogVisible = true;
    },
    cancelOrderClick() {
      this.dialogType = "cancel_order";
      this.dialogTitle = "请选择撤单原因";
      this.dialogVisible = true;
    },
    recallOrderClick() {
      this.dialogType = "recall_order";
      this.dialogTitle = "请输入撤回原因";
      this.dialogVisible = true;
    },
    toOrderComplete() {
      this.dialogType = "order_complete";
      this.dialogTitle = "确认完成";
      this.dialogVisible = true;
    },
    refoundClick() {
      this.dialogType = "refound";
      this.dialogTitle = "退款";
      this.dialogVisible = true;
    },
    refuseRefoundClick() {
      this.dialogType = "refuse-refound";
      this.dialogTitle = "拒绝退款";
      this.dialogVisible = true;
    },
    closeOrderClick() {
      this.dialogType = "close_order";
      this.dialogTitle = "关闭订单";
      this.dialogVisible = true;
    }
  }
};
</script>

<style lang="less" scoped>
.detail-header-wrap {
  display: flex;
  justify-content: space-between;
  .btn {
    margin-right: 10px;
  }
}
.img-wrap {
  display: flex;
  flex-wrap: wrap;
  .situation_img {
    width: 200px;
    height: 200px;
    margin-right: 20px;
  }
}
.title {
  margin-bottom: 30px;
  font-size: 20px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(76, 76, 76, 1);
  line-height: 28px;
}
.sub-title {
  display: inline-block;
  margin-right: 30px;
  font-size: 16px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
}
.item {
  line-height: 50px;
}
.order-info-wrap {
  display: flex;
  margin-bottom: 30px;
  .order-status {
    color: red;
  }
  .goods_url {
    display: inline-block;
    height: 100px;
    width: 300px;
    padding: 10px;
    border: 1px solid #000;
    border-radius: 10px;
    word-wrap: break-word;
  }
  .left {
    margin-right: 150px;
  }
}
.salesmaninfo-wrap {
  display: flex;
  margin-bottom: 30px;
  .item {
    margin-right: 80px;
  }
}
.seller-info-wrap {
  margin-top: 30px;
  .item-wrap {
    display: flex;
    flex-wrap: wrap;
    .item {
      display: flex;
      margin-right: 40px;
      line-height: 30px;
      .link {
        padding: 5px 10px;
        border: 1px solid #e5e5e5;
        border-radius: 5px;
      }
    }
  }
}
.auth-wrap {
  margin-top: 30px;
  .auth-text {
    max-width: 350px;
    padding: 10px;
    text-align: center;
    border: 1px solid #000;
    border-radius: 10px;
  }
}
.situation-wrap {
  margin-top: 30px;
  .situation-tag {
    max-width: 200px;
    padding: 10px;
    margin-bottom: 10px;
    text-align: center;
    border: 1px solid #000;
    border-radius: 10px;
  }
  .situation-desc {
    width: 600px;
    min-height: 200px;
    height: auto;
    padding: 10px 20px;
    margin-bottom: 30px;
    border: 1px solid #000;
    border-radius: 10px;
  }
}
.backBtn {
  display: block;
  margin: 40px auto;
}
.dialog-body-wrap {
  text-align: center;
  .dispatch-wrap {
    .dispatch_input {
      width: 200px;
    }
  }
  .dialog-remark-color-wrap {
    display: flex;
    justify-content: space-around;
    margin-bottom: 20px;
  }
  .img-wrap {
    text-align: left;
  }
  .color_selected {
    border: 2px solid #000;
  }
  .commission_input-wrap {
    position: relative;
    margin-top: 20px;
    .input-label {
      display: block;
      position: relative;
      right: 62px;
    }
    .commission_rate {
      width: 186px;
    }
  }
  .radio-group {
    display: flex;
    flex-direction: column;
    text-align: left;
    /deep/.el-radio {
      line-height: 30px;
    }
  }
  .follow_record_wrap {
    text-align: left;
    .record_tag {
      display: inline-block;
      text-align: center;
      max-width: 150px;
      width: auto;
      padding: 5px 10px;
      border: 1px solid #000;
      border-radius: 5px;
    }
  }
}
</style>
